import C from './constants'

export const setAtomicMassValues = (val) => (
    {
        type: C.SET_ATOMIC_MASS_VALUES,
        payload: val
    }
)